import { IActivitiesTypes, IStartEvent } from './types';

export function getStartEventRequest(id: string) {
  return {
    type: IActivitiesTypes.GET_START_EVENT_REQUEST,
    payload: { id },
  };
}

export function getStartEventSuccess(startEvent: IStartEvent) {
  return {
    type: IActivitiesTypes.GET_START_EVENT_SUCCESS,
    payload: { startEvent },
  };
}

export function getStartEventFailure() {
  return {
    type: IActivitiesTypes.GET_START_EVENT_FAILURE,
  };
}
